import React from 'react';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import { CustomDatePicker } from '../../../../../components/CustomDatePicker';
import { CustomTextField } from '../../../../../components/CustomTextField';
import { CustomSelect } from '../../../../../components/CustomSelect';
import { useTranslation } from 'react-i18next';
import GetDateFilter from '../Functionality/GetDateFilter';
import {ATTENDANCE_MODES, ATTENDANCE_MODES_LIST} from "../../../Dining/Manage/Models/Model";
import {CalenderInputButton} from "../../../../../components/buttons/IconButtons";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * @param selectedOption - The currently selected option for filtering
 * @param setSelectedOption - Function to set the selected option
 * @param selectedDate - The currently selected date for filtering
 * @param setSelectedDate - Function to set the selected date
 * @param prevIsDaily
 */
const DateFilter = ({ selectedOption, setSelectedOption, selectedDate, setSelectedDate, handleChange }) => {
    const {t} = useTranslation();

    const handleSelectChange = (e) => {
        if(handleChange) handleChange();
        setSelectedOption(e.target.value);
    };

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const { currentFortnightData, currentWeekOfYearWithWeekdays, currentMonthDates } = GetDateFilter();

    return (
        <div className='row'>
            <Box className="col-sm-12 col-md-3 col-xxl-3 col-lg-3">
                <CustomSelect
                    id='slt_df_frequency'
                    name='frequency'
                    list={ATTENDANCE_MODES_LIST()}
                    value={selectedOption}
                    onChange={handleSelectChange}
                    trans='select_option'
                    required={true}
                    emptyFields={selectedOption === '' || selectedOption === null}
                    keyName='id'
                    showNoSelectionOption={false}
                />
            </Box>

            {selectedOption === ATTENDANCE_MODES.biweekly && (
                <>
                    <Box className="col-sm-12 col-md-3 col-xxl-3 col-lg-3">
                        <CustomDatePicker
                            id={'dp_df_start_date'}
                            name={'startDate'}
                            trans={'startDate'}
                            disabled={true}
                            value={currentFortnightData.startOfFortnight}
                            required={false}
                            emptyFields={false}
                            disableFuture={false}
                        />
                    </Box>

                    <Box className="col-sm-12 col-md-3 col-xxl-3 col-lg-3">
                        <CustomDatePicker
                            id={'dp_df_end_date'}
                            name={'endDate'}
                            disabled={true}
                            trans={'end_date'}
                            value={currentFortnightData.endOfFortnight}
                        />
                    </Box>

                    <Box className="col-sm-12 col-md-3 col-xxl-3 col-lg-3">
                        <CustomTextField
                            size='small'
                            type='text'
                            id='txt_df_current_fortnight'
                            trans='current_fortnight'
                            value={currentFortnightData.biweekly}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <CalenderInputButton/>
                                    </InputAdornment>
                                ),
                                readOnly: true,
                            }}
                            disabled={true}
                            helperText=''
                        />
                    </Box>
                </>
            )}

            {selectedOption === ATTENDANCE_MODES.daily && (
                <Box className="col-sm-12 col-md-3 col-xxl-3 col-lg-3">
                    <CustomDatePicker
                        id='dtp_df_current_date'
                        name={'current'}
                        disabled={true}
                        trans={'current'}
                        value={selectedDate}
                        onChange={handleDateChange}
                    />
                </Box>
            )}

            {selectedOption === ATTENDANCE_MODES.weekly && (
                <>
                    <Box className="col-sm-12 col-md-3 col-xxl-3 col-lg-3">
                        <CustomDatePicker
                            id='dp_df_start_date'
                            name={'startDate'}
                            disabled={true}
                            trans={'start_date'}
                            value={currentWeekOfYearWithWeekdays.startOfWeek}
                        />
                    </Box>

                    <Box className="col-sm-12 col-md-3 col-xxl-3 col-lg-3">
                        <CustomDatePicker
                            id='dp_df_end_date'
                            name={'endDate'}
                            disabled={true}
                            trans={'end_date'}
                            value={currentWeekOfYearWithWeekdays.endOfWeek}
                        />
                    </Box>

                    <Box className="col-sm-12 col-md-3 col-xxl-3 col-lg-3">
                        <CustomTextField
                            size='small'
                            fullWidth
                            type='text'
                            id='txt_df_week'
                            trans='current_week_of_the_year'
                            value={currentWeekOfYearWithWeekdays.weekOfYear}
                            InputProps={{
                                inputMode: 'numeric',
                                pattern: '[0-9]*',
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <CalenderInputButton/>
                                    </InputAdornment>
                                ),
                                readOnly: true,
                            }}
                            disabled={true}
                        />
                    </Box>
                </>
            )}

            {selectedOption === ATTENDANCE_MODES.monthly && (
                <>
                    <Box className="col-sm-12 col-md-3 col-xxl-3 col-lg-3">
                        <CustomDatePicker
                            id='dp_df_start_date_month'
                            name={'startDate'}
                            disabled={true}
                            trans={'start_date'}
                            value={currentMonthDates.firstDay}
                        />
                    </Box>

                    <Box className="col-sm-12 col-md-3 col-xxl-3 col-lg-3">
                        <CustomDatePicker
                            id='dp_df_end_date_month'
                            name={'endDate'}
                            disabled={true}
                            trans={'end_date'}
                            value={currentMonthDates.lastDay}
                        />
                    </Box>

                    <Box className="col-sm-12 col-md-3 col-xxl-3 col-lg-3">
                        <CustomTextField
                            size='small'
                            fullWidth
                            type='text'
                            id='txt_df_current_month'
                            trans='current_month'
                            value={t(currentMonthDates.monthName)}
                            InputProps={{
                                inputMode: 'text',
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <CalenderInputButton/>
                                    </InputAdornment>
                                ),
                                readOnly: true,
                            }}
                            disabled={true}
                        />
                    </Box>
                </>
            )}
        </div>
    );
};

export default DateFilter;
